import React, { useContext, useMemo } from 'react'
import { getTranslate } from 'react-localize-redux'
import DataTable from '../../../Components/shared/DataTable/DataTable'
import { ORDER_BY, ROLE_INSTITUTION_GROUP_ADMIN } from '../../../utils/constants'
import { Sector, getComment, getEmplacement, getInstitutionName, getName } from '../../../utils/entities/sector'
import { ACTIONS, Action, DeleteAction, ExternalAction } from '../../../Components/shared/DataTable/utils/actions'
import { connect } from 'react-redux'
import { faBox, faEdit, faExchangeAlt } from '@fortawesome/free-solid-svg-icons'
import ArchivedSectorsModal from '../../../Components/institution/ArchivedSectorsModal'
import { getUser } from '../../../reducers/UserReducer'
import SelectInstitutionFilter from '../../../Components/shared/DataTable/utils/SelectInstitutionFilter'
import { InstitutionGroupContext } from '../../../Providers/InstitutionGroupProvider'
import { GlobalFiltersContext } from '../../../Providers/GlobalFiltersProvider'
import { Filter } from '../../../Components/shared/DataTable/utils/tableFilter'
import Cookies from 'js-cookie'

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale),
    user: getUser(state.getUser)
  }
}

const SectorsTable = ({ data, institution = null, loading, metadata, parameters, user, onParametersChange, onTriggerAction, t }) => {
  const igContext = useContext(InstitutionGroupContext)
  const { selectedInstitution, setSelectedInstitution } = useContext(GlobalFiltersContext)

  const maxHeight = useMemo(() => `calc(100vh - ${Cookies.get('switch_user_id') ? '180px' : '139px'})`, [Cookies.get('switch_user_id')])
  const columns = useMemo(() => {
    const columns = [
      {
        title: t('sectors_table.column_title.name'),
        orderBy: ORDER_BY.NAME,
        key: i => {
          const name = getName(i)
          const maxLength = !institution ? 50 : 30

          return name.length > maxLength ? `${name.slice(0, maxLength - 3)}...` : name
        },
        tooltip: getName
      }
    ]

    if (institution === null) {
      columns.push({
        title: t('sectors_table.column_title.institution'),
        orderBy: ORDER_BY.INSTITUTION,
        key: i => {
          const name = getInstitutionName(i)

          return name.length > 50 ? `${name.slice(0, 47)}...` : name
        },
        tooltip: getInstitutionName
      })
    }

    columns.push(
      { title: t('sectors_table.column_title.comment'), orderBy: ORDER_BY.COMMENT, key: getComment },
      { title: t('sectors_table.column_title.emplacement'), orderBy: ORDER_BY.EMPLACEMENT, key: getEmplacement }
    )

    return columns
  }, [institution, t, getComment, getEmplacement, getName])
  const actions = useMemo(() => {
    const actions = [new Action({ title: 'institutions_view.actions.edit_institution', icon: faEdit, onClick: s => onTriggerAction(s, ACTIONS.EDIT_SECTOR) })]

    if (user.roles.includes(ROLE_INSTITUTION_GROUP_ADMIN)) {
      actions.push(new Action({ title: 'institutions_view.actions.switch_institution', icon: faExchangeAlt, onClick: s => onTriggerAction(s, ACTIONS.SWITCH_SECTOR) }))
    }

    actions.push(new DeleteAction({
      onDelete: s => onTriggerAction(s, ACTIONS.ARCHIVE_SECTOR),
      title: 'Archive',
      icon: faBox,
      popconfirmTitle: 'delete_action.pop_confirm.archive_sector'
    }))

    return actions
  }, [onTriggerAction])
  const externalActions = useMemo(() => [
    new ExternalAction({
      Component: ArchivedSectorsModal,
      key: 'archive',
      props: {
        institution: institution,
        unarchive: s => onTriggerAction(s, ACTIONS.UNARCHIVE_SECTOR),
        onDelete: s => onTriggerAction(s, ACTIONS.DELETE)
      },
      title: t('sectors_table.external_actions.display_archive_sectors')
    })
  ], [institution, onTriggerAction, t, user])

  const filters = useMemo(() => {
    const filters = []

    if (institution === null && user.roles.includes(ROLE_INSTITUTION_GROUP_ADMIN)) {
      filters.push(new Filter({
        key: 'institution',
        label: t('Institution'),
        component: SelectInstitutionFilter,
        props: { institutions: igContext?.institutions, value: selectedInstitution, onChange: setSelectedInstitution }
      }))
    }

    return filters
  }, [user, igContext?.institutions, selectedInstitution, setSelectedInstitution, t])

  return (
    <div style={{ height: maxHeight }}>
      <DataTable
        actions={actions}
        columns={columns}
        data={data}
        externalActions={externalActions}
        filters={filters}
        loading={loading}
        metadata={metadata}
        parameters={parameters}
        onCreate={() => onTriggerAction(new Sector({ institution }), ACTIONS.CREATE_SECTOR)}
        onParametersChange={onParametersChange}
      />
    </div>
  )
}

export default connect(mapStateToProps)(SectorsTable)
